import AppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';

import { NavLink } from 'react-router-dom';
import Logo from '../images/miwf.png';
import Box from '@mui/material/Box';


function Header(props) {
  return (
    <AppBar
      position="fixed"
      sx={{
        display: {
          md: 'none'
        }
      }}
    >
      <Toolbar
      sx={{
        display: 'flex',
        gap: '32px',
        justifyContent: 'space-between',
      }}
      
      >
        <NavLink to="/">
        <Box
			component="img"
			sx={{ height: 35 }}
			alt="Logo"
			src={Logo}
		  />
        </NavLink>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={props.function}
          sx={{ mr: 2,}}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
export default Header;